module.exports = __webpack_public_path__ + "img/transport_pic01.5a79513e.jpg";